/*
 * Seizoensdrop-blok: werkt de aftelteller bij.
 *
 * Liquid rekent het aantal dagen al uit, zodat de teller ook klopt als
 * JavaScript uit staat. Maar de pagina wordt gecacht, dus dat getal kan een
 * dag achterlopen. Dit script herberekent het bij het laden.
 */
(function () {
  'use strict';

  var MS_PER_DAY = 86400000;

  function daysUntil(dateString) {
    var parts = String(dateString).split('-');
    if (parts.length !== 3) return null;

    var target = Date.UTC(Number(parts[0]), Number(parts[1]) - 1, Number(parts[2]));
    if (isNaN(target)) return null;

    var now = new Date();
    var today = Date.UTC(now.getFullYear(), now.getMonth(), now.getDate());
    var diff = Math.ceil((target - today) / MS_PER_DAY);

    return diff > 0 ? diff : 0;
  }

  function updateCountdown(root) {
    var countdown = root.querySelector('[data-seasonal-drop-countdown]');
    var daysEl = root.querySelector('[data-seasonal-drop-days]');
    if (!countdown || !daysEl) return;

    var days = daysUntil(root.getAttribute('data-launch-date'));
    if (days === null) return;

    if (days <= 0) {
      countdown.hidden = true;
      return;
    }

    daysEl.textContent = String(days);
    countdown.hidden = false;
  }

  function init() {
    var roots = document.querySelectorAll('[data-seasonal-drop]');

    for (var i = 0; i < roots.length; i++) {
      updateCountdown(roots[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
